import React, { Component } from 'react';




class PageILPF extends Component {
  render() {
    return(    
        <div id="body">
          <h1 id="body-h1">O QUE É ILPF?</h1>
          <p>
            A integração lavoura-pecuária- floresta (ILPF) é uma estratégia de produção que integra diferentes sistemas produtivos, agrícolas, pecuários e florestais dentro de uma mesma área. Pode ser feita em cultivo consorciado, em sucessão ou em rotação, de forma que haja benefício mútuo para todas as atividades.
            <br/><br/>
            Esta forma de sistema integrado busca otimizar o uso da terra, elevando os patamares de produtividade, diversificando a produção e gerando produtos de qualidade. Com isso reduz a pressão sobre a abertura de novas áreas.
                <br/><br/><br/><br/>
                <a href="https://www.embrapa.br/web/rede-ilpf">Click aqui para saber mais sobre ILPF</a>
          </p>
        </div>
    );
  }
}

export default PageILPF;



// WEBPACK FOOTER //
// ./src/Pages/PageILPF.js